<template>
  <b-card>
    <g-table
      ref="transaction-table"
      :items="items"
      :columns="tableColumns"
      :is-busy="isTableBusy"
      :noAction="true"
      perPage="25"
      :totalRows="totalRows"
      :createButton="{ visiable: true }"
      :searchInput="{ visiable: true }"
      @on-create="
        (v) => {
          this.$router.push({ name: 'discountCode-new' });
        }
      "
    >
      <template #actions="{ item }">
        <div class="text-nowrap d-inline-flex">
          <b-form-checkbox
            checked="true"
            class="custom-control-primary mt-25"
            name="check-button"
            v-model="item.isActive"
            @change="
              (v) => {
                activation(item);
              }
            "
            switch
          >
            <span class="switch-icon-left">
              <feather-icon icon="EyeIcon" />
            </span>
            <span class="switch-icon-right">
              <feather-icon icon="EyeOffIcon" />
            </span>
          </b-form-checkbox>
          <b-button
            data-action-type="delete"
            v-b-tooltip.hover.top="$t('delete')"
            variant="flat-danger"
            class="btn-icon"
            size="sm"
            @click="
              (v) => {
                remove(item);
              }
            "
          >
            <feather-icon
              icon="TrashIcon"
              stroke="red"
              class="danger"
              :id="`invoice-row-${item.id}-delete-icon`"
            />
          </b-button>
        </div>
      </template>
    </g-table>
  </b-card>
</template>

<script>
import GTable from '@/pages/Shared/Table.vue';

export default {
  components: {
    GTable,
  },
  data() {
    return {
      searchQuery: '',
      currentPage: 1,
      perPage: 25,
      isTableBusy: false,
      totalRows: 0,
      items: [],
      totalVals: 0,
    };
  },
  computed: {
    tableColumns() {
      return [
        { key: 'name', label: this.$t('name'), sortable: false },
        { key: 'code', label: this.$t('code'), sortable: false },
        {
          key: 'percentage',
          label: this.$t('percentage'),
          sortable: true,
        },
        {
          key: 'creationDateUtc',
          label: this.$t('creationDate'),
          sortable: true,
          formatter: (value, key, item) => {
            return this.getDate(item.creationDateUtc);
          },
        },
        {
          key: 'endDate',
          label: this.$t('endDate'),
          sortable: true,
          formatter: (value, key, item) => {
            return this.getDate(item.endDate);
          },
        },
        { key: 'actions' },
      ];
    },
  },
  mounted() {
    this.getDiscountCodes();
  },
  methods: {
    activation(item) {
        if (item.isActive) {
          this.confirmActivate(
            {
              text: this.$t('areYouSureYouWantToActivate'),
            },
            () => {
              this.create({
                url: `DiscountCode/activate/${item.id}`,
              }).then(() => {
                this.doneAlert({ text: this.$t('changeSuccessfully') });
                this.getDiscountCodes();
              });
            }
          );
        } else {
          this.confirmActivate(
            {
              text: this.$t('areYouSureYouWantToDeActivate'),
            },
            () => {
              this.create({
                url: `DiscountCode/deActivate/${item.id}`,
              }).then(() => {
                this.doneAlert({ text: this.$t('changeSuccessfully') });
                this.getDiscountCodes();
              });
            }
          );
        }
    },
    getDiscountCodes() {
      this.get({ url: 'DiscountCode' }).then((data) => {
        this.items = data;
      });
    },
    remove(item) {
      this.confirmAction(
        {
          text: this.$t('areYouSureYouWantToDelete'),
        },
        () => {
          this.delete({
            url: 'DiscountCode',
            id: item.id,
          }).then(() => {
            this.doneAlert({ text: this.$t('deletedSuccessfully') });
            this.getDiscountCodes();
          });
        }
      );
    },
    edit(item) {
        this.$router.push({
          name: 'discountCode-edit',
          params: { id: item.id },
        });
    },
  },
};
</script>

<style></style>
